export function DocumentTextIcon({
  className = 'text-fx-neutral-600',
}: {
  className?: string;
}) {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <g id="document-text">
        <path
          id="Icon"
          d="M9 12H15M9 16H15M17 20H7C5.89543 20 5 19.1046 5 18V6C5 4.89543 5.89543 4 7 4H12.5858C12.851 4 13.1054 4.10536 13.2929 4.29289L18.7071 9.70711C18.8946 9.89464 19 10.149 19 10.4142V18C19 19.1046 18.1046 20 17 20Z"
          stroke="currentColor"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
    </svg>
  );
}
